import barcode_regex from "@pdfking/constants/barcode"
import { last } from "@pdfking/rfunc"
import { startswith } from "@pdfking/workflow/utils/strings"
export default (query: string): string => {
  // @ts-expect-error TS2550
  const cleaned = query.replaceAll(barcode_regex.divider, " ") as string
  const barcodes = cleaned.split(barcode_regex.divider)
  const barcode = last(barcodes)

  if (
    barcode &&
    barcode_regex.barcode.test(barcode) &&
    barcode.length == 11 &&
    barcode.substr(3) == barcode.substr(3).toLowerCase() &&
    (startswith(barcode, "44X") ||
      startswith(barcode, "43X") ||
      startswith(barcode, "41X"))
  ) {
    return `${cleaned} `
  }
  return cleaned || ""
}
